import React from 'react';
import type { FC } from 'react';
import process from 'node:process';
import { Box, Text } from '@wix/cli-ui-kit';
import { useSite } from '../../../site/index.js';
import type { ScreenState } from './screen-state.js';
import { SwitchSite } from './SwitchSite.js';
import { RedirectLink } from '../../PlatformLink/RedirectLink.js';
import { useDevEnvironment } from '../DevEnvironment.js';

interface HomeScreenProps {
  onScreenChange: (screen: ScreenState) => void;
}

export const HomeScreen: FC<HomeScreenProps> = ({ onScreenChange }) => {
  const { siteId } = useSite();
  const { devArmTag } = useDevEnvironment();

  return (
    <>
      <Box gap={1}>
        <Text>Current Dev Site:</Text>
        <Text bold skin="info">
          {siteId}
        </Text>
        {process.stdin.isTTY && <SwitchSite onScreenChange={onScreenChange} />}
      </Box>

      <Box paddingTop={1} paddingBottom={1} flexDirection="column">
        <Text>Open the preview on:</Text>
        <Box paddingLeft={2} flexDirection="column">
          <RedirectLink
            platform="site"
            versionOverrideId={devArmTag}
            siteId={siteId}
          />
          <RedirectLink
            platform="editor"
            versionOverrideId={devArmTag}
            siteId={siteId}
          />
          <RedirectLink
            platform="dashboard"
            versionOverrideId={devArmTag}
            siteId={siteId}
          />
        </Box>
      </Box>
    </>
  );
};
